import { ButtonLink } from "~/shared/components/ds/ButtonLink";
import {
  ErrorDisplayActions,
  ErrorDisplayContent,
  ErrorDisplayHeadline,
  ErrorDisplayLockup,
  ErrorDisplayLogo,
  ErrorDisplayMessage,
  ErrorDisplayRoot,
} from "~/shared/components/errors/ErrorDisplay";
import { JOB_PATHS } from "~/team/constants/paths.constants";

export function GamePlanNotFound({ children }: { children: React.ReactNode }) {
  return (
    <ErrorDisplayRoot>
      <ErrorDisplayLogo />
      <ErrorDisplayContent>
        <ErrorDisplayLockup>
          <ErrorDisplayHeadline>Game plan unavailable</ErrorDisplayHeadline>
          <ErrorDisplayMessage>
            This game plan isn&apos;t available right now. Browse your current game plans, or try reloading the page.
          </ErrorDisplayMessage>
        </ErrorDisplayLockup>
        <ErrorDisplayActions>{children}</ErrorDisplayActions>
      </ErrorDisplayContent>
    </ErrorDisplayRoot>
  );
}

export function TeamGamePlanNotFound() {
  return (
    <GamePlanNotFound>
      <ButtonLink variant="default" to={JOB_PATHS.gamePlan()}>
        View Game Plans
      </ButtonLink>
    </GamePlanNotFound>
  );
}
